import script from "./ESignature.vue?vue&type=script&setup=true&lang=js"
export * from "./ESignature.vue?vue&type=script&setup=true&lang=js"

import "./ESignature.vue?vue&type=style&index=0&id=d4ecf1de&lang=css"

const __exports__ = script;

export default __exports__